import React from 'react';
import CampaignsLayout from './campaigns-layout';

export default class Campaigns extends React.Component<{}, {}> {
    render(){
        return(
            <CampaignsLayout/>
        )
    }
}